import Styles from './ExamPoints.scss';

import Template from './ExamPoints.hbs';
export default class ExamPoints extends BaseView {

    initialize({
        response,
        activityModel,
        isPreview,
        isExportingExamAnswers,
    }) {

        const attainablePoints = activityModel.getAttainableExamPoints(this.model.id);
        let isGraded = true;

        // Calculate how many points the student got, based on the score
        let pointsReceived = activityModel.getExamPointsFromScore(
            this.model.id,
            response.get('score')
        );

        // If the answer has no score
        if (pointsReceived === -1) {

            // If the student did not answer the question, show 0 points
            if (response.get('json_answer') === undefined) {
                pointsReceived = 0
                isGraded = true

            // If the student did answer, but was not graded, show a question mark
            } else {
                isGraded = false
                pointsReceived = '?'
            }
        }

        this.setElement(Template({
            Styles,
            showReceivedPoints: isExportingExamAnswers ||
                (activityModel.get('show_answers') && !isPreview),
            pointsReceived: pointsReceived.toLocaleString(),
            isGraded,
            attainablePoints: attainablePoints.toLocaleString(),
        }));

        this.$('.js-unit').text(window.i18n.ngettext('point', 'points', attainablePoints));
    }

}
